<template>
  <div class="audio-player">
    <audio
      ref="audio"
      @timeupdate="updateTime"
      @loadedmetadata="loadMetadata"
      @ended="onEnded"
    >
      <source :src="audioSrc" type="audio/mpeg" />
      Your browser does not support the audio element.
    </audio>
    <div class="controls">
      <div class="play-btn">
        <img v-if="isPlaying" @click="handlePause" class="icon-pause" src="@/assets/img/voiceComposeCustom/pause.png"/>
        <img v-else @click="handlePlay" class="icon-play" src="@/assets/img/voiceComposeCustom/play.png" />
      </div>
      <span class="time">{{ formatTime(currentTime) }} / {{ formatTime(duration) }}</span>
      <input
        class="progress-bar"
        type="range"
        min="0"
        :max="duration"
        step="0.1"
        v-model="currentTime"
        @input="seek"
      />
      <el-select class="playback-rate" popper-class="playback-popper" v-model="playbackRate" @change="changePlaybackRate">
        <el-option v-for="rate in playbackRates" :key="rate" :value="rate">
          {{ rate }}
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "VoiceComposerPlayer",
  props: {
    audioSrc: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      playbackRate: '1.0x',
      playbackRates: ['0.5x', '1.0x', '1.5x', '2.0x'],
      volume: 1,
    };
  },
  methods: {
    handlePause() {
      const audio = this.$refs.audio;
      audio.pause();
      this.isPlaying = false;
    },
    handlePlay() {
      const audio = this.$refs.audio;
      audio.play();
      this.isPlaying = true;
    },
    togglePlay() {
      const audio = this.$refs.audio;
      if (this.isPlaying) {
        audio.pause();
      } else {
        audio.play();
      }
      this.isPlaying = !this.isPlaying;
    },
    updateTime() {
      this.currentTime = this.$refs.audio.currentTime;
      // 更新进度条CSS变量
      const progressBar = this.$el.querySelector('.progress-bar');
      progressBar.style.setProperty('--value', this.currentTime);
      progressBar.style.setProperty('--min', 0);
      progressBar.style.setProperty('--max', this.duration);
    },
    loadMetadata() {
      this.duration = this.$refs.audio.duration;
      // 初始化进度条CSS变量
      const progressBar = this.$el.querySelector('.progress-bar');
      progressBar.style.setProperty('--value', 0);
      progressBar.style.setProperty('--min', 0);
      progressBar.style.setProperty('--max', this.duration);
    },
    seek() {
      this.$refs.audio.currentTime = this.currentTime;
    },
    changePlaybackRate() {
      this.$refs.audio.playbackRate = parseFloat(this.playbackRate.replace('x', ''));
    },
    changeVolume() {
      this.$refs.audio.volume = this.volume;
    },
    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
    },
    onEnded() {
      this.isPlaying = false;
      this.currentTime = 0;
    },
  },
};
</script>

<style lang="less" scoped>
.audio-player {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.controls {
  display: flex;
  align-items: center;
}

.play-btn {
  cursor: pointer;
  width: 20px;
  height: 20px;
  margin-right: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.play-btn img {
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}

.time {
  font-family: PingFang-SC, PingFang-SC;
  font-weight: 500;
  font-size: 12px;
  color: #323B4B;
  // line-height: 17px;
  margin-right: 14px;
}

.progress-bar {
  flex: 1;
  appearance: none;
  height: 4px;
  background: #E6E9ED;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
  width: 280px;
  position: relative; // 添加相对定位

  // 已播放部分的背景色
  &::-webkit-slider-runnable-track {
    height: 4px;
    border-radius: 5px;
    background: linear-gradient(
      to right,
      #41B48C 0%,
      #41B48C calc((var(--value) - var(--min)) / (var(--max) - var(--min)) * 100%),
      #E6E9ED calc((var(--value) - var(--min)) / (var(--max) - var(--min)) * 100%),
      #E6E9ED 100%
    );
  }

  // 滑块样式
  &::-webkit-slider-thumb {
    appearance: none;
    width: 14px;
    height: 14px;
    background: #41B48C;
    border-radius: 50%;
    cursor: pointer;
    margin-top: -5px; // 垂直居中调整
    position: relative;
    z-index: 2;
  }
}

.playback-rate {
  width: 80px;
  cursor: pointer;
  // margin-left: 15px;
  font-family: PingFang-SC, PingFang-SC;
  font-weight: 800;
  font-size: 18px;
  color: #41B48C;
  line-height: 25px;
}
</style>
<style lang="less">
.playback-popper .el-select-dropdown__item.selected {
  color: #41B48C !important;
}

.playback-rate.el-select .el-input__inner {
  border: none;
  font-family: PingFang-SC, PingFang-SC;
  font-weight: 800;
  font-size: 18px;
  color: #41B48C;
  padding: 0 0 0 15px;
}

.playback-rate.el-select .el-input__suffix {
  display: none;
}
</style>